import 'react-app-polyfill/ie11'; // this line always comes first!!!
import 'react-app-polyfill/stable';
import './core/config/i18n';
import './index.css';

import { LicenseManager } from '@ag-grid-enterprise/core';
import * as am4core from '@amcharts/amcharts4/core';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import { environment } from './core/config/environment';
import * as serviceWorker from './core/config/serviceWorker';

if (environment.AGGRID_LICENCE_KEY) {
  LicenseManager.setLicenseKey(environment.AGGRID_LICENCE_KEY);
}
if (environment.AMCHART_LICENCE_KEY) {
  am4core.addLicense(environment.AMCHART_LICENCE_KEY);
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
